import React from 'react';
import './warframe.css';

const WarframePage = () => {
  return (
    <main className="warframe-page">
      <section className="warframe-card">
        <h1>Venatores Arcanum Recruitment</h1>
        <p className="warframe-lead">Welcome to the Venatores Arcanum!</p>

        <p>
          Recruiting anyone from MR 15+. The clan does not have researches open yet as the dojo is still a
          work in progress, but if you already have all the dojo weapons unlocked, you should join.
        </p>

        <p>
          We are slowly working our way through our researches though, so you will be notified when the
          items are up for grabs.
        </p>

        <p>Dojo builders and visionnaires are welcome! Discord is optional but highly recommended.</p>

        <a
          className="warframe-discord-btn"
          href="https://go.brogverse.cc/warframe"
          target="_blank"
          rel="noreferrer"
        >
          To Our Discord
        </a>
      </section>
    </main>
  );
};

export default WarframePage;
